import { useEffect, useRef } from 'react';
import QRCode from 'qrcode';

interface QRCodeCanvasProps {
  value: string;
  size?: number;
  className?: string;
}

export function QRCodeCanvas({ value, size = 256, className }: QRCodeCanvasProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (canvasRef.current) {
      QRCode.toCanvas(canvasRef.current, value, {
        width: size,
        margin: 1,
        color: {
          dark: '#2D2F7E',  // Farmso purple
          light: '#FFFFFF',
        },
      });
    }
  }, [value, size]);

  return <canvas ref={canvasRef} className={className} />;
}
